// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
}

.dialog-header {
  margin-bottom: 20px;
}

.dialog-body {
  margin-bottom: 20px;
}

.dialog-actions {
  text-align: right;
}

.input-field {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
}

.btn-primary {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 5px 10px; /* Reduced padding */
  font-size: 12px;   /* Reduced font size */
  border-radius: 5px;
  cursor: pointer;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 5px 10px; /* Reduced padding */
  font-size: 12px;   /* Reduced font size */
  border-radius: 5px;
  cursor: pointer;
}

img {
  transition: all 0.3s ease;
  cursor: pointer;
}

img.inactive {
  height: 50px;
  width: 50px;
}

img.active {
  height: 80px;
  width: 80px;
}

img:hover {
  filter: brightness(0.8);
}
`, "",{"version":3,"sources":["webpack://./src/components/tracktrace/CustomDialog.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB,EAAE,oBAAoB;EACvC,eAAe,IAAI,sBAAsB;EACzC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB,EAAE,oBAAoB;EACvC,eAAe,IAAI,sBAAsB;EACzC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.dialog-content {\n  background-color: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  width: 400px;\n}\n\n.dialog-header {\n  margin-bottom: 20px;\n}\n\n.dialog-body {\n  margin-bottom: 20px;\n}\n\n.dialog-actions {\n  text-align: right;\n}\n\n.input-field {\n  width: 100%;\n  padding: 8px;\n  margin-top: 5px;\n}\n\n.btn-primary {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 5px 10px; /* Reduced padding */\n  font-size: 12px;   /* Reduced font size */\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.btn-secondary {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  padding: 5px 10px; /* Reduced padding */\n  font-size: 12px;   /* Reduced font size */\n  border-radius: 5px;\n  cursor: pointer;\n}\n\nimg {\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\nimg.inactive {\n  height: 50px;\n  width: 50px;\n}\n\nimg.active {\n  height: 80px;\n  width: 80px;\n}\n\nimg:hover {\n  filter: brightness(0.8);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
